import { render, staticRenderFns } from "./TabletAppStatus.vue?vue&type=template&id=63af7db8&"
import script from "./TabletAppStatus.vue?vue&type=script&lang=js&"
export * from "./TabletAppStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports